import {
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { AuthService, User } from '../../services/auth.service';
import { Observable } from 'rxjs';
import { BUTTON_STYLES } from '../../constants/constants';

@Component({
  selector: 'app-auth-button',
  templateUrl: './auth-button.component.html',
  styleUrls: ['./auth-button.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AuthButtonComponent {
  protected readonly BUTTON_STYLES = BUTTON_STYLES;

  public user$: Observable<User | null> = this.authService.user$;
  public isProfileNavigationOpen: boolean = false;

  @Output() logout = new EventEmitter();

  constructor(public authService: AuthService) {}

  toggleIsProfileNavigationOpen(): void {
    this.isProfileNavigationOpen = !this.isProfileNavigationOpen;
  }
}
